<div class="table-filters-selector" (keyup.escape)="onOverlayClick()">
    <div class="selected-filters-container" (click)="toggleDropdown()" [attr.aria-label]="'Show label dropdown' | translate">
        <label class="input clearfix">
            <div *ngFor="let name of getModelKeys(); trackBy: trackByFn">
                <ul class="list-inline pull-left" *ngIf="isSubFilterArray(model[name]) && model[name]">
                    <li *ngFor="let item of model[name]; trackBy: trackByIndex"
                        class="cursor-pointer"
                        [attr.aria-label]="name + ':' + item.name"
                        (click)="toggleSubFilter($event, name, item)"
                        (keyup.enter)="toggleSubFilter($event, name, item)"
                        tabindex="0"
                        role="button"
                    >
                        {{ name | capitalize }}: {{ item.name }}
                        <span class="remove-filter" role="button" [attr.aria-label]="'Close' | translate">
                            <span class="fas fa-times-circle" aria-hidden="true"></span>
                        </span>
                    </li>
                </ul>
                <ul class="list-inline pull-left" *ngIf="!isSubFilterArray(model[name]) && model[name]">
                    <li>
                        {{ name | capitalize }}: {{ model[name] }}
                        <span class="remove-filter"
                              (click)="toggleSubFilter($event, name, model[name])"
                              (keyup.enter)="toggleSubFilter($event, name, model[name])"
                              role="button">
                            <span class="fas fa-times-circle" aria-hidden="true"></span>
                        </span>
                    </li>
                </ul>
            </div>
        </label>
    </div>
    <div class="table-filters-selector-overlay" *ngIf="showDropdown" (click)="onOverlayClick()" [attr.aria-label]="'Label overlay' | translate"></div>
    <div class="tfs-dropdown-menu root slide-down" *ngIf="showDropdown">
        <ul class="list-unstyled">
            <li class="group" [attr.aria-label]="'Select filters' | translate" translate>
                Select filters
            </li>
            <li class="tfs-submenu cursor-pointer"
                (click)="openSubMenuHandler(name)"
                (keyup.enter)="openSubMenuHandler(name)"
                *ngFor="let name of getFilterKeys(); trackBy: trackByFn"
                [ngClass]="{ 'selected': openSubMenu === name }"
                [attr.aria-label]="name"
                [attr.aria-selected]="openSubMenu === name"
                role="button"
                tabindex="0"
            >
                <span>{{ name | capitalize | translate }}</span>
                <div class="tfs-dropdown-menu items" *ngIf="openSubMenu === name && isSubFilterArray(filters[name])">
                    <ul class="list-unstyled">
                        <li class="label-header" [attr.aria-label]="'Filter by' | translate">
                            <span class="fas fa-filter" aria-hidden="true"></span>
                            &nbsp;
                            <span translate>Filter by:</span>
                            <strong>{{ name | capitalize }}</strong>
                            <span class="fas fa-times dropdown-close"
                                  (click)="closeSubMenu($event)"
                                  (keyup.enter)="closeSubMenu($event)"
                                  tabindex="0"
                                  role="button"></span>
                        </li>
                        <li class="label-search-box" [attr.aria-label]="'Search' | translate" *ngIf="filters[name].length >= 5">
                            <span [attr.aria-label]="'Search icon' | translate" class="fas fa-search"></span>
                            <input type="search" [(ngModel)]="subMenuSearch" [name]="'subMenuSearch'" id="subMenuSearch" [attr.aria-label]="'Search' | translate" [placeholder]="'Search' | translate">
                        </li>
                    </ul>

                    <ul class="list-unstyled options">
                        @for (item of getFilteredItems(filters[name]); track item.name) {
                            <li class="label-item"
                                (click)="toggleSubFilter($event, name, item)"
                                (keyup.enter)="toggleSubFilter($event, name, item)"
                                tabindex="0"
                                role="button"
                            >
                                <table-filters-selector-item [item]="item" [filter]="name" [selected]="isSubFilterItemSelected(name, item)" [template]="selectorItemTemplate"></table-filters-selector-item>
                            </li>
                        }
                    </ul>
                </div>

                <div class="tfs-dropdown-menu items" *ngIf="openSubMenu === name && !isSubFilterArray(filters[name])">
                    <ul class="list-unstyled">
                        <li class="label-header">
                            <span class="fas fa-filter" aria-hidden="true"></span>
                            &nbsp;
                            <span translate>Filter by:</span>
                            <strong>{{ name | capitalize }}</strong>
                            <span class="fas fa-times dropdown-close"
                                  (click)="closeSubMenu($event)"
                                  (keyup.enter)="closeSubMenu($event)"
                                  role="button"
                                  tabindex="0"></span>
                        </li>
                    </ul>
                    <ul class="list-unstyled options">
                        <li class="label-item" *ngFor="let item of filters[name].options" (click)="toggleSubFilter($event, name, item)">
                            <table-filters-selector-item [item]="item" [filter]="name" [selected]="isSubFilterItemSelected(name, item)" [template]="selectorItemTemplate"></table-filters-selector-item>
                        </li>
                    </ul>
                </div>
            </li>
        </ul>
    </div>
</div>
